<template>
  <div class="prod-container">
    <nav class="add-navigation">
      <div
        @click="$router.push({ name: 'system-admin-product' })"
        class="back-link"
      >
        <svg
          class="icon"
          width="30px"
          height="30px"
          viewBox="0 0 30 30"
          version="1.1"
        >
          <path
            d="M9.82106781,14.25 L23,14.25 L23,16.25 L9.84421387,16.25 L11.6568542,18.0626404 L10.2426407,19.4768539 L7.41842728,16.6526405 L7.41421356,16.6568542 L7.00735931,16.25 L7,16.25 L7,16.2426407 L6,15.2426407 L6.00421371,15.238427 L6,15.2342133 L7.41421356,13.8199997 L7.41842728,13.8242134 L10.2426407,11 L11.6568542,12.4142136 L9.82106781,14.25 Z"
            id="path-1"
          />
        </svg>
        <p>Back to products</p>
      </div>
      <div class="buttons-wrapper">
        <div
          @click="$router.push({ name: 'system-admin-product' })"
          class="secondary-button"
        >
          <secondary-button>Cancel</secondary-button>
        </div>
        <div class="primary-button">
          <primary-button @click.native="editProduct"
            >Save product</primary-button
          >
        </div>
      </div>
    </nav>
    <div class="add-container">
      <span class="container-title">Edit Product Companies</span>
      <div class="cont">
        <div class="el-transfer-box">
          <div class="input">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
              <path
                fill="currentColor"
                d="M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"
              />
            </svg>
            <input type="text" class="search-input" @input="searchDid" />
          </div>
        </div>
        <div class="col-wrapper">
          <el-transfer
            v-model="product.companies"
            :titles="['All Companies', 'Assigned Companies']"
            :data="filteredCompanies"
          ></el-transfer>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "AddProductCompany",
  components: {
    PrimaryInput: () => import("@/components/Inputs/PrimaryInput.vue"),
    PrimarySelect: () => import("@/components/Inputs/PrimarySelect.vue"),
    SecondaryButton: () => import("@/components/Buttons/SecondaryButton.vue"),
    PrimaryButton: () => import("@/components/Buttons/PrimaryButton.vue"),
  },
  data: () => ({
    productError: null,
    product: {
      companies: [],
    },
    productId: null,
    companies: [],
    filteredCompanies: [],
  }),
  computed: {
    ...mapGetters({
      getProduct: "products/getProduct",
    }),
  },
  created() {
    this.getCompanyList();
    this.getProductCompanies();
  },
  methods: {
    ...mapActions({
      viewProduct: "products/getProduct",
      edit: "products/editProduct",
    }),
    searchDid(e) {
      const val = e.target.value;

      if (val === "") {
        this.filteredCompanies = this.companies;
        return;
      }

      this.filteredCompanies = this.companies.filter((item) => {
        return item.label.toLowerCase().indexOf(val.toLowerCase()) === 0;
      });
    },
    async getProductCompanies() {
      this.productId = this.$route.params.id;

      if (this.$store.state.products.products.length !== 0) {
        const result = this.$store.state.products.products.filter(
          (product) => product.product_uuid === this.productId
        );
        this.product.companies = result[0].companies;
      } else {
        await this.viewProduct(this.productId);
        this.product.companies = this.getProduct.companies;
      }
    },
    transformCompany(item) {
      return {
        key: item.company_uuid,
        label: item.company_name,
      };
    },
    getCompanyList() {
      this.$store.dispatch("GetCompanyList", {}).then((res) => {
        let { total } = res;
        this.$store
          .dispatch("GetCompanyList", { per_page: total })
          .then((res) => {
            this.companies = res.items.map(this.transformCompany);
            this.filteredCompanies = this.companies;
          });
      });
    },
    editProduct() {
      this.$validator.validate().then((result) => {
        if (result) {
          this.edit({ id: this.productId, product: this.product })
            .then(() => {
              this.$snotify.success("Product companies have been edited.", {
                timeout: 6000,
              });
              this.$router.push({ name: "system-admin-product" });
            })
            .catch((err) => {
              if (err.errors) {
                this.productError = err.errors[0].product
                  ? err.errors[0].product
                  : null;
                setTimeout(() => {
                  this.productError = null;
                }, 6000);
              } else {
                this.$snotify.error("Company is added to another product", {
                  timeout: 6000,
                });
              }
            });
        }
      });
    },
  },
};
</script>

<style>
.el-transfer {
  width: 700px;
  margin-top: 40px;
  /* margin: 40px auto 0; */
  /* transform: translateX(-50%); */
}
.el-transfer-panel {
  width: 300px;
}
</style>

<style lang="scss" scoped>
.prod-container {
  width: 100%;
  font-family: "Helvetica Neue";
  padding: 0 20px;

  .add-navigation {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 40px;
    width: 100%;
    margin-top: 20px;
    margin-bottom: 20px;
    .back-link {
      cursor: pointer;
      display: flex;
      align-items: center;
      fill: #51a3f3;
      color: #51a3f3;
      font-family: "Helvetica Neue";
      font-size: 16px;
      font-weight: 500;
      line-height: 20px;
      p {
        margin-bottom: 0;
      }
    }
    .buttons-wrapper {
      display: flex;
      align-items: center;
      width: fit-content;
      .primary-button {
        height: 40px;
        width: 140px;
      }
      .secondary-button {
        height: 40px;
        width: 90px;
        margin-right: 20px;
      }
    }
  }
  .add-container {
    flex-direction: column;
    align-items: center;
    // height: 375px;
    background-color: #ffffff;
    padding: 15px 0 25px;

    .cont {
      width: 700px;
      margin: 0 auto;
    }
    .container-title {
      height: 30px;
      width: 432px;
      color: #000000;
      font-size: 16px;
      font-weight: 500;
      line-height: 30px;
      padding: 15px 0 15px 15px;
    }
    .el-transfer-box {
      margin-top: 20px;
      // padding-left: 15px;

      .input {
        position: relative;

        svg {
          position: absolute;
          top: 10px;
          top: 13px;
          left: 8px;
          z-index: 2;
          width: 20px;
          width: 16px;

          path {
            fill: #999;
          }
        }
        .search-input {
          position: absolute;
          top: 0;
          left: 0;
          width: 300px;
          padding: 8px 15px 8px 35px;
          border: 1px solid #ebeef5;
          border-radius: 4px;
        }
      }
    }
    .col-wrapper {
      // width: 100%;
      width: fit-content;
      display: flex;
      justify-content: space-between;
      margin-top: 20px;
      // padding-left: 15px;

      .col {
        width: 100%;
        margin-right: 15px;
        padding: 0;
        .input {
          margin-bottom: 20px;
        }
        .field {
          p.pimary-input-title {
            color: #000000;
            font-family: "" Helvetica Neue "";
            font-size: 12px;
            font-weight: 300;
          }
        }
        .type {
          margin-top: 20px;
        }
        .pimary-input-title {
          color: #000000;
          font-family: "" Helvetica Neue "";
          font-size: 12px;
          font-weight: 300;
          letter-spacing: 0.21px;
          line-height: 15px;
          margin-bottom: 5px;
          text-transform: uppercase;
        }
      }
    }
    .email-input {
      margin-bottom: 20px;
    }
    .password-input {
      margin-bottom: 30px;
    }
    .first {
      margin-bottom: 30px;
      .remember-me {
        display: flex;
        align-items: center;
        input {
          margin-right: 5px;
        }
      }
    }
  }
}
</style>

